export const PHONE = "+212661471841";
export const PHONE_LABEL = "+212 661 471 841";
export const EMAIL = "cristal.inox@yahoo.fr";

export const whatsappLink = (text) =>
  `https://wa.me/${PHONE.replace("+", "")}?text=${encodeURIComponent(text)}`;
